import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ_ITEMS: FAQItem[] = [
  {
    question: 'How do I remove a video background without a green screen?',
    answer:
      'Simply upload your video to ReelCat and our AI will automatically detect and remove the background — no green screen, chroma key, or manual masking required. The AI model processes each frame to separate the subject from the background.',
  },
  {
    question: 'What video formats and sizes are supported?',
    answer:
      'We support MP4, WebM, and MOV video files. Videos can be up to 1 minute long and 100MB in size. Most smartphone and camera recordings work out of the box.',
  },
  {
    question: 'Is it free to remove video backgrounds?',
    answer:
      'Yes, the background removal tool is free to use. You just need to create a free ReelCat account to process your video. There are no watermarks on the output.',
  },
  {
    question: 'How long does processing take?',
    answer:
      'Most videos are processed in 30 to 90 seconds depending on the length and resolution. The AI runs on dedicated GPU servers for fast turnaround.',
  },
  {
    question: 'What can I do with the background-removed video?',
    answer:
      'You can download the transparent video file directly, or click "Edit in ReelCat" to open it in our full video editor where you can add new backgrounds, captions, effects, music, and more.',
  },
];

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="mt-16 md:mt-24">
      <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center mb-8">
        Frequently Asked Questions
      </h2>
      <div className="max-w-3xl mx-auto divide-y divide-border">
        {FAQ_ITEMS.map((item, index) => (
          <div key={index}>
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="flex items-center justify-between w-full py-5 text-left gap-4"
            >
              <span className="text-base font-medium text-foreground">
                {item.question}
              </span>
              <ChevronDown
                className={`w-5 h-5 flex-shrink-0 text-muted-foreground transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <p className="pb-5 text-sm text-muted-foreground leading-relaxed">
                {item.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
